export const EXTERNAL_SERVICE_INTEGRATIONS_ENABLED: boolean = false;
export const NEW_URL_BANNER_FEATURE: boolean = true;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./ts/components/feature-flags.ts